import db from '@/firebase/init'

/**
 * firestore.rules read the caller's church from userAccess/{uid}, which the
 * syncUserAccess function copies from the users doc (GitHub #132). After the
 * client sets a church (first sign-in from an invite, or a church PIN), church
 * reads and writes are refused until that copy lands, so wait for it.
 *
 * Resolves true once userAccess has the church, false after the timeout.
 */
export function waitForUserAccess(uid, cid, timeoutMs = 15000) {
  return new Promise((resolve) => {
    let finished = false
    let stop = null
    const finish = (ok) => {
      if (finished) return
      finished = true
      clearTimeout(timer)
      if (stop) stop()
      resolve(ok)
    }
    const timer = setTimeout(() => finish(false), timeoutMs)
    stop = db
      .collection('userAccess')
      .doc(uid)
      .onSnapshot(
        (snap) => {
          if (snap.exists && snap.get('cid') === cid) finish(true)
        },
        () => finish(false)
      )
    if (finished) stop()
  })
}
